import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import * as content from '../../../content'
import { Store } from '../../store'

/**
 * Slideout panel that hosts the assistant UI; renders the gear icon
 * that opens the agent context configuration modal.
 */
@ngCore.Component({
  imports: [
    ds.overlay.slideout.Component,
    content.assistant.Component,
    content.assistant.configuration.Component,
  ],
  selector: 'atn-assistant-slideout',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** Owns the agent-configuration editing session and persisted values. */
  private readonly _configFeature = ngCore.inject(
    state.assistant.configuration.Feature,
  )

  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.assistants.Assistants} */
  public readonly assistants = ngCore.inject(state.assistants.Assistants)

  /**
   * Indicates this slideout should be closed
   */
  public readonly close = ngCore.output()

  /**
   * Whether the configuration modal is open. Sourced from the
   * configuration feature so the modal can be opened/closed by any
   * dispatcher, not just this component.
   */
  public readonly isConfigOpenSg =
    this._configFeature.selectors.isEditing.asSignal

  /** Opens the agent context configuration modal. */
  public openConfig(
    agentId: ents.core.agent.Agent.Id,
    conversationId: ents.core.agent.Conversation.Id | undefined,
  ): void {
    if (!this.assistants.selectedAgentCanConfigureFunctionalitySg()) {
      return
    }

    this._configFeature.actions.startEditing
      .from('AssistantSlideout.openConfig')
      .dispatch({ agentId, conversationId })
  }
}
